import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { authApi } from "@/lib/api/auth";
import { useAuthStore } from "@/store/authStore";

export function useStopImpersonate() {
  const [isPending, setIsPending] = useState(false);
  const navigate = useNavigate();
  const { stopImpersonation, logout } = useAuthStore();

  const stop = async () => {
    setIsPending(true);
    try {
      // Halt + escalate if runtime rejects inferred shape (F33 carry-forward).
      const response = await authApi.stopImpersonate();
      stopImpersonation(response.tokens.access, response.tokens.refresh);
      toast.success("Impersonation ended");
    } catch (error: unknown) {
      const code = (
        error as {
          response?: { data?: { error?: { code?: string } } };
        }
      ).response?.data?.error?.code;
      if (code === "actor_unavailable") {
        logout();
        navigate("/login");
        toast.error("Original account no longer available. Signed out.");
      } else if (code === "not_impersonating") {
        toast.error("Not in an impersonation session.");
      } else {
        toast.error("Failed to stop impersonation");
      }
    } finally {
      setIsPending(false);
    }
  };

  return { stop, isPending };
}
